export default __webpack_public_path__ + "static/media/A0006.95085b6b.png";